import PropTypes from 'prop-types';

const Series = ({ color, size, ...props }) => (
    <svg viewBox="0 0 20 20" width={size} height={size} {...props}>
        <path
            d="M18.165 13.437a.625.625 0 0 1-.227.853l-7.5 4.375a.63.63 0 0 1-.63 0l-7.5-4.375a.625.625 0 0 1 .63-1.08l7.187 4.191 7.188-4.19a.625.625 0 0 1 .852.226m-.852-3.977-7.188 4.192L2.938 9.46a.625.625 0 0 0-.626 1.08l7.5 4.375a.63.63 0 0 0 .63 0l7.5-4.375a.627.627 0 0 0 .07-1.043.63.63 0 0 0-.7-.037M2 6.25a.63.63 0 0 1 .313-.54l7.5-4.375a.63.63 0 0 1 .63 0l7.5 4.375a.625.625 0 0 1 0 1.08l-7.5 4.375a.63.63 0 0 1-.63 0l-7.5-4.375A.63.63 0 0 1 2 6.25m1.866 0 6.259 3.652 6.26-3.652-6.26-3.652z"
            fill={color}
        />
    </svg>
);

export default Series;

Series.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
